<template>
  <div id="app" class="">
    <div class="uk-hidden">
      ボードゲーム it’s a wonderful world ( イッツアワンダフルワールド ) の 全カード検索 カード一覧 カードリスト オンライン 荒廃と隆盛 拡張
    </div>
    <div class="uk-section uk-background-cover" :style="{backgroundImage: 'url(' + header_img+ ')'}">
      <div class="uk-text-center shadow">
        <div class="uk-visible@s uk-text-large">
          イッツアワンダフルワールド カード検索
        </div>
        <div class="uk-hidden@s title-slim">
          イッツアワンダフルワールド カード検索
        </div>
      </div>
    </div>
    <div class="uk-container">
      <div>
        <router-view></router-view>
      </div>
      <div class="uk-section uk-text-center uk-text-muted">
        2020.11
        <a href="https://twitter.com/akechisan">@akechisan</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        header_img: require("./assets/river.jpg"),
      }
    },
    components: {},
  }

</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #4a4a4a;
    background-color: #f3f3f3;
    margin-top: 0;
  }

  .title-slim {
    transform: scaleX(0.9)
  }

  .shadow {
    color: #ffffff;
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 1),
    0px 0px 10px rgba(0, 0, 0, 1),
    0px 0px 10px rgba(0, 0, 0, 1),
    0px 0px 10px rgba(0, 0, 0, 1),
    0px 0px 10px rgba(0, 0, 0, 1),
    0px 0px 10px rgba(0, 0, 0, 1),
    0px 0px 10px rgba(0, 0, 0, 1),
    0px 0px 10px rgba(0, 0, 0, 1);

  }
</style>
